// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2kCFB","col":"Table_col__2JAIt","fulfillmentStatus":"Table_fulfillmentStatus__17N4-","emailCol":"Table_emailCol__3VZ46"};